// ============================================================
// SubmissionPage.jsx — 접수관리 탭 (/submissions)
//
// [하는 일]
//   일반인 접수 목록을 보여주고 승인·반려한다.
//   권한(rt_permissions 'submissions')이 없으면 안내만 띄운다.
//
// [권한]
//   서버가 /api/submissions/* 를 requirePerm 으로 막고 있다.
//   여기서는 403 응답을 받아 안내 화면으로 바꿀 뿐이며,
//   실제 차단은 서버가 한다(프론트만 고쳐서는 우회할 수 없다).
//
// [연관]
//   components/SubmissionInbox.jsx  목록·승인 UI
//   backend/routes/staffIntake.js   목록·승인 API
//   pages/PublicIntake.jsx          일반인 접수 화면 (/register)
// ============================================================
import React from "react";
import { useNavigate } from "react-router-dom";
import SubmissionInbox from "../components/SubmissionInbox";

// SubmissionInbox 가 관리탭 카드용 스타일을 props 로 받으므로
// 이 페이지에서도 비슷한 모양을 만들어 넘긴다.
const cardStyle = {
  background: "#fff",
  border: "1px solid #e5e5e5",
  borderRadius: 12,
  padding: 20,
  maxWidth: 900,
  margin: "20px auto",
};
const titleStyle = {
  fontSize: 18,
  fontWeight: 800,
  marginBottom: 6,
  display: "flex",
  alignItems: "center",
};
const subTitleStyle = {
  fontSize: 13,
  color: "#777",
  lineHeight: 1.6,
};

export default function SubmissionPage() {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  // 비로그인 — 접수 화면으로 안내한다
  if (!token) {
    return (
      <div style={{ ...cardStyle, textAlign: "center", padding: "60px 20px" }}>
        <h2 style={{ fontSize: 20, marginBottom: 12 }}>접수관리</h2>
        <p style={{ color: "#777", lineHeight: 1.8, marginBottom: 24 }}>
          이 화면은 담당자 전용입니다.<br />
          매물을 내놓으시려면 아래에서 접수해 주세요.
        </p>
        <button
          onClick={() => navigate("/register")}
          style={{
            padding: "14px 32px", background: "#1a2b4a", color: "#fff",
            border: 0, borderRadius: 8, fontSize: 16, fontWeight: 700,
            cursor: "pointer",
          }}
        >
          매물 접수하러 가기
        </button>
      </div>
    );
  }

  return (
    <div style={{ padding: "0 12px" }}>
      <SubmissionInbox
        cardStyle={cardStyle}
        titleStyle={titleStyle}
        subTitleStyle={subTitleStyle}
      />
    </div>
  );
}